import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";

const name = "EtiquetaPedidoAguardandoAprovacao";

export default {
  name,
  components: {
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
  },

  props: {},

  mounted() {
    this.GetEtiquetaDoPedido();
  },

  updated() {},

  data() {
    return {
      codigoPedido: null,
      nomeFantasia: null,
      nomeProduto: null,
    };
  },

  methods: {
    voltar() {
      this.$router.push(`/andamento-de-pedidos`);
    },

    GetEtiquetaDoPedido() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API + `Pedido/GetPedidoAguardandoAprovacaoEtiqueta/${this.$route.params.id}`,
      })
        .then((response) => {
          this.codigoPedido = response.data.data.codigoPedido;
          this.nomeFantasia = response.data.data.nomeFantasia;
          this.nomeProduto = response.data.data.nomeProduto;
        })
        .catch(() => {});
    },
  },

  computed: {},
};
